/* eslint-disable no-restricted-syntax */
import React, {useMemo} from 'react';

import {useClientServerEffect} from 'coreHooks';
import useSSRStyle from 'coreHooks/useSSRStyle';

import Grid from 'brandComponents/Grid';

import {constructGridCssStyle} from '../../helpers';
import {EGridSpacing} from '../../IGridContentful';

import {IGridContentfulRowProps, TGridRowAttrs} from './IGridContentfulRow';

const GridContentfulRow = (props: IGridContentfulRowProps) => {
	const {addStyle, deleteStyle} = useSSRStyle();

	const {classesStyles, classesKeys, classesNames} = useMemo(() => {
		const classes = constructGridCssStyle(
			props.sys.id,
			props.spacing,
			props.alignment
		);

		const styles = Object.entries(classes || {});
		const keys = Object.keys(classes || {});
		const names = keys.join(' ');

		return {classesStyles: styles, classesKeys: keys, classesNames: names};
	}, [props.sys.id, props.spacing, props.alignment]);

	useClientServerEffect(() => {
		classesStyles.forEach(([className, style]) => addStyle(className, style as string));

		return () => classesKeys.forEach((key) => deleteStyle(key));
	}, []);

	const attrs: TGridRowAttrs = {};

	// Edge-to-edge row
	if (props.edgeToEdge) {
		attrs.edgeToEdge = props.edgeToEdge;
	}

	// Add spacing
	if (props.verticalGutters) {
		attrs['verticalGutters'] = EGridSpacing[props.verticalGutters];
	}

	// Add borders
	if (props.horizontalBorders) {
		attrs['horizontalBorders'] = props.horizontalBorders;
	}

	if (props.horizontalGutters) {
		attrs['horizontalGutters'] = EGridSpacing[props.horizontalGutters];
	}

	return (
		<Grid.Row classNames={classesNames} {...attrs}>
			{props.children}
		</Grid.Row>
	);
};

export default GridContentfulRow;
